import * as React from 'react';
import * as Common from './Common';

// export class TogglerIcon extends React.Component<{
//     setOn: boolean;
// }, {}> {
//     render() {
//         return (
//             <span className={ this.props.setOn ? 'fa fa-toggle-on' : 'fa fa-toggle-off' }></span>
//         );
//     }
// }

export interface IMenuItemProperties {
    icon?: string;
    toggleIconState?: boolean;
    title?: string;
    children?: React.ReactNode;
    top?: boolean;
    bottom?: boolean;

    onClick?(e): void;
}

export default function MenuItem(props: IMenuItemProperties) {
    const handleOnClick = (e) => {
        if (props.onClick != null) {
            props.onClick(e);
        }
    };

    let icon;
    // if (props.toggleIconState != null) {
    //     icon = <TogglerIcon setOn={ props.toggleIconState } />
    // }
    const isClickable = props.onClick != null;

    let iconName = props.icon;

    if (iconName != null) {
        if (isClickable) {
            iconName += ' clickable';
        }

        icon = <span className={ iconName }></span>;
    }

    return (
        <div
            className={ 'menu-item' + (props.top ? ' top' : '') + (props.bottom ? ' bottom' : '') }
            title={ props.title }
        >
            <div className={ 'menu-item-icon' + (isClickable ? ' clickable' : '') } onClick={ handleOnClick }>
                { icon }
            </div>
            <div className="menu-item-component">{ props.children }</div>
        </div>
    );
}

export interface IButtonMenuItemProperties extends IMenuItemProperties {
    title?: string;
    isActive?: boolean;
    data?: Common.IMenuItemData;
}

export function ButtonMenuItem(props: IButtonMenuItemProperties) {
    const handleOnClick = (e) => {
        if (props.onClick != null) {
            props.onClick(e);
        }
    };

    let buttonClass = 'dropdown-item pl-1';

    if (props.isActive === true) {
        buttonClass += ' active';
    }

    let icon = props.icon;

    if (icon == null && props.data != null) {
        icon = props.data.icon;
    }

    let title = props.title;

    if (title == null && props.data != null) {
        title = props.data.title;
    }

    return (
        <MenuItem
            icon={ icon }
            title={ props.title }
            top={ props.top }
            bottom={ props.bottom }
            onClick={ props.onClick }
        >
            <span className={ buttonClass } onClick={ handleOnClick }>
                { title }
            </span>
        </MenuItem>
    );
}

export function Divider() {
    return <div className="menu-item-divider"></div>;
}
